import { AnswerInterface } from "../../domain/interfaces/answer_interface";
import { SurveyAnswerRepository } from "../../domain/repository/survey_answer_repository";
import { SurveyAnswerApiService } from "../data_source/survey_answer_api_service";


export class SurveyAnswerRepositoryImpl implements SurveyAnswerRepository {
    private surveyAnswerApiService: SurveyAnswerApiService;

    constructor() {
        this.surveyAnswerApiService = new SurveyAnswerApiService();
    }

    async answerQuestion(answer: AnswerInterface): Promise<AnswerInterface | undefined> {
        const response = await this.surveyAnswerApiService.answerQuestion(answer);

        if (response.status === 201) {
            return {
                id: response.data._id,
                questionId: response.data._surveyQuestionId,
                answer: response.data.answer,
                text: response.data.text || "",
            }
        }
        return undefined;
    }

    async modifyAnswer(answer: AnswerInterface, answerId: string): Promise<AnswerInterface | undefined> {
        const response = await this.surveyAnswerApiService.modifyAnswer(answer, answerId);
        if (response.status === 200) {
            return {
                id: response.data._id,
                questionId: response.data._surveyQuestionId,
                answer: response.data.answer,
                text: response.data.text || "",
            }
        }
        return undefined;
    }

    async commentSurvey(comment: string, surveyId: string): Promise<string | null> {
        const response = await this.surveyAnswerApiService.commentSurvey({ comment }, surveyId);
        if (response.status === 201) {
            return response.data.answer;
        }
        return null;
    }

    async modifySurveyComment(comment: string, surveyId: string): Promise<string | null> {
        const response = await this.surveyAnswerApiService.modifySurveyComment({ comment }, surveyId);
        if (response.status === 200) {
            return response.data.answer;
        }
        return null;
    }
}
